/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
const select = {
  styleOverrides: {
    root: {
      minHeight: "var(--control-md, 40px)",
      borderRadius: "var(--radius-md, 10px)",
      backgroundColor: "var(--surface-primary)",
      color: "var(--text-primary)",
      fontFamily: "var(--font-family-primary, 'Lexend', sans-serif)",
      fontSize: "var(--font-size-body-sm, 14px)",
      transition:
        "border-color var(--duration-fast, 150ms) var(--easing-standard, ease), box-shadow var(--duration-fast, 150ms) var(--easing-standard, ease)",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--border-strong)",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--interactive-default)",
        borderWidth: 2,
      },
      "&.Mui-focused": {
        boxShadow:
          "var(--field-focus-ring, 0 0 0 3px rgba(15, 186, 196, 0.22))",
      },
      "&.Mui-disabled": {
        backgroundColor: "var(--surface-secondary)",
        color: "var(--text-disabled)",
      },
    },
    select: {
      display: "flex",
      alignItems: "center",
      minHeight: "var(--control-md, 40px)",
      boxSizing: "border-box",
      padding: "0 36px 0 var(--space-3, 12px) !important",
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      display: "block",
      right: "var(--space-3, 12px)",
      width: "var(--icon-sm, 18px)",
      height: "var(--icon-sm, 18px)",
      color: "var(--text-secondary)",
      fontSize: "18px !important",
    },
  },
};

export default select;
